import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "download", "target"]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  href?: string;
  download?: string;
  to?: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
}

export default /*#__PURE__*/_defineComponent({
  __name: 'inline-link',
  props: {
    modifires: { type: [String, Array, Boolean] },
    href: {},
    download: {},
    to: {},
    target: {}
  },
  setup(__props: any) {

const props = __props;



const componentClass = () => mapModifires("inline-link", props.modifires);

return (_ctx: any,_cache: any) => {
  return (_ctx.href)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: _normalizeClass(componentClass()),
        href: _ctx.href,
        download: _ctx.download,
        target: _ctx.target
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(componentClass()),
        type: "button"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
}
}

})